module.exports = __webpack_public_path__ + "static/media/instruments-spanish.44d335b5.png";